import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import styled from 'styled-components';
import { zIndex10000 } from '../../styles/zIndex.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "fullscreen", "open"];
var BackdropDiv = styled.div.withConfig({
  displayName: "Backdrop__BackdropDiv",
  componentId: "sc-z57190-0"
})(["&&{position:", ";inset:0;top:0;right:0;bottom:0;left:0;background-color:#fff;display:flex;justify-content:center;align-items:center;z-index:", ";}"], function (props) {
  return props.fullscreen ? "fixed" : "absolute";
}, zIndex10000);
function Backdrop(_ref) {
  var children = _ref.children,
    fullscreen = _ref.fullscreen,
    open = _ref.open,
    props = _objectWithoutProperties(_ref, _excluded);
  return open ? /*#__PURE__*/jsx(BackdropDiv, _objectSpread(_objectSpread({
    fullscreen: fullscreen
  }, props), {}, {
    children: children
  })) : null;
}
Backdrop.displayName = "Backdrop";

export { Backdrop };
